import * as React from 'react';
import { HelloDesktop } from '@cian/quiz-component';
import { IHttpApi } from '@cian/http-api';
import { QuizModal } from '../QuizModal';
import { getShowQuiz, getQuestions, postDoNotDisturb } from '../../../api/quiz';
import { IShowQuizResponse, EStatus } from '../../../../shared/repositories/quiz/v1/show-quiz';
import { IGetQuestionRequest } from '../../../../shared/repositories/quiz/v1/get-question';

export interface IQuiz {
  subdomain: string;
  httpApi: IHttpApi;
}

export const QuizComponent: React.FC<IQuiz> = ({ httpApi, subdomain }) => {
  const [helloModalState, setShowModalState] = React.useState<IShowQuizResponse>({
    quizId: null,
    status: 'noActive' as EStatus,
  });
  const { quizId, status } = helloModalState;
  const [isHelloModalOpenState, setIsHelloModalOpenState] = React.useState<boolean>(false);
  const [isQuizModalOpenState, setIsQuizModalOpenState] = React.useState<boolean>(false);

  React.useEffect(() => {
    getShowQuiz(httpApi, { subdomain }).then(({ response }) => {
      setShowModalState({ ...response });
      setIsHelloModalOpenState(true);
    });
  }, [getShowQuiz]);

  const handleSubmit = React.useCallback(() => {
    setIsHelloModalOpenState(false);
    setIsQuizModalOpenState(true);
  }, [getQuestions]);

  const handleCancel = () => {
    if (quizId) {
      postDoNotDisturb(httpApi, { quizId });
    }
  };

  const handleCloseModal = () => {
    setIsQuizModalOpenState(false);
  };

  const closeQuizModalWithTimer = (ms: number) => {
    setTimeout(() => {
      setIsQuizModalOpenState(false);
    }, ms);
  };

  return (
    <>
      {quizId && status === 'ok' && isHelloModalOpenState && (
        <HelloDesktop callbackSubmit={handleSubmit} callbackCancel={handleCancel} />
      )}
      {quizId && (
        <QuizModal
          quizId={quizId}
          isModalOpen={isQuizModalOpenState}
          getQuestions={(params?: IGetQuestionRequest) => getQuestions(httpApi, { ...params, subdomain })}
          closeModal={handleCloseModal}
          closeQuizModalWithTimer={closeQuizModalWithTimer}
        />
      )}
    </>
  );
};
